import { createQuery } from 'react-query-kit';

import * as Types from '../api/features/types.api';
import * as FeatureAPI from '../api/features/index.api';

//
//

const key = 'features';

//

export const useQueryMerchantFeaturesGet = createQuery<
  Types.FeaturesListResponse,
  Types.FeaturesListQuery
>({
  queryKey: [key, 'merchant'],
  fetcher: (params) => FeatureAPI.getFeaturesAPI(params),
});
